import * as React from 'react';

import { MoreVert } from '@material-ui/icons';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';

import AdminFeedbackModal from './AdminFeedbackModal';
import { allowProjectResubmit } from '../../../services/apiService';
import { toast } from 'react-toastify';

const ITEM_HEIGHT = 48;

export function ActionCellRenderer(params) {
  const [openAdminFeedbackModal, setOpenAdminFeedbackModal] =
    React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAllowResubmit = async () => {
    try {
      await allowProjectResubmit({
        userId: params.data.userId,
        projectId: params.data.projectId,
        reEvaluationRequested: false,
      });
      toast.success('Resubmit allowed successfully');
      handleClose();
      // Refresh the grid data
      if (params.context?.refreshGrid) {
        params.context.refreshGrid();
      }
    } catch (error) {
      console.error('Error allowing resubmit:', error);
      toast.error('Failed to allow resubmit');
    }
  };

  return (
    <div>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MoreVert />
      </IconButton>

      <Menu
        id='long-menu'
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            if (params?.data?.evaluationStatus === 'pending') return;
            setOpenAdminFeedbackModal(true);
          }}
        >
          <div
            className={
              params?.data?.evaluationStatus === 'pending'
                ? 'text-gray-400'
                : ''
            }
          >
            Change Evaluation
          </div>
        </MenuItem>
        
        {params?.data?.reEvaluationRequested === 1 &&
          (params?.data?.adminStatus === 'on_hold' ||
            params?.data?.evaluationStatus === 'rejected') && (
            <MenuItem onClick={handleAllowResubmit}>
              <div>Allow Resubmit</div>
            </MenuItem>
          )}
      </Menu>

      <AdminFeedbackModal
        params={params}
        openModal={openAdminFeedbackModal}
        setOpenModal={setOpenAdminFeedbackModal}
      />
    </div>
  );
}
